import service from '@/services/facturacion/pago'

// defaultSaldoCliente {
//   simbolo: '',
//   totalMonto: 0,
//   totalpagado: 0,
//   totalFacturas: 0,
//   saldo: null
// }

const getDefaultState = () => ({
  pago: {
    aplicaBalance: false, // si es true, aplica el balance positivo del cliente por pagos extra.
    fecha: '',
    monto: 0,
    estado: true,
    concepto: '',

    medioPago: {
      id: ''
    },
    detalle: '', // detalle del medio de pago: monto, numero de cuenta, tajeta de credito, o detalle en general del pago
    cuentaContable: ''

    // updatedAt: '',
    // createdAt: ''
  },
  aplicaBalance: false, // si es true, aplica el balance positivo del cliente por pagos extra.
  // saldo total de un cliente
  saldoCliente: [],

  lista: [], // pagos de multiples facturas cargadas en pantalla (factura electronica, credito, compras, credito compras, etc)
  listaPagosFactura: [], // pagos de una factura
  listaPagosTiquete: [], // pagos de un tiquete
  listaPagosFacturaCompras: [], // pagos de una factura de compras
  listaPagosOtros: [], // pagos de una factura
  listaPagosFacturaCredito: [], // pagos de una factura en la vista de Crédito (facturacion - credito)
  listaPagosFacturaCreditoCompras: [], // pagos de una factura en la vista de Crédito Comras (compras - cuentas por pagar)
  listaPagosProforma: [], // pagos de una proforma

  listaPago: [], // pagos de un emisor
  pagoPageInfo: {},

  listaPagoCompras: [], // reporte de pagos de compras

  listaPagoCliente: [], // pagos de un cliente específico
  listaPagoProveedor: [], // pagos de un proveedor específico
  listaCreditoCliente: [], // facturas a credito de un cliente específico
  listaCreditoProveedor: [], // facturas a credito de un proveedor específico

  listaClientes: [], // lista de pagos, facturas y saldos por cliente (usado en reportes de ventas)
  listaProveedor: [], // lista de pagos, facturas y saldos por proveedor (usado en reportes de compras)

  listaPagos: [], // lista de pagos generales (inf scroll)
  listaPagosPageInfo: {},

  listaPagosCompras: [], // lista de pagos compras generales (inf scroll)
  listaPagosComprasPageInfo: {},

  listaCuentasCobrar: [],
  listaCuentasPagar: [],
  listaIngresos: [],
  listaEgresos: [],

  balanceAccount: {
    ingresos: 0,
    egresos: 0
  },

  totalRegistros: 0,
  totalRegistrosCompras: 0,

  currentRow: null
})

export const state = () => getDefaultState()

export const mutations = {
  SET_LISTA: (state, obj) => {
    state.lista.push(obj)
  },
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LISTA_FACTURA: (state, { storeList, obj }) => {
    state[storeList] = obj
  },
  SET_LISTA_CUENTAS_COBRAR: (state, obj) => {
    state.listaCuentasCobrar = obj
  },
  SET_LISTA_CUENTAS_COBRAR_COMPRAS: (state, obj) => {
    state.listaCuentasPagar = obj
  },
  SET_LISTA_INGRESOS: (state, obj) => {
    state.listaIngresos = obj
  },
  SET_LISTA_EGRESOS: (state, obj) => {
    state.listaEgresos = obj
  },
  SET_LISTA_PAGO: (state, obj) => {
    state.listaPago = obj
  },
  SET_LISTA_PAGO_COMPRAS: (state, obj) => {
    state.listaPagoCompras = obj
  },
  SET_LISTA_PAGO_CLIENTE: (state, obj) => {
    state.listaPagoCliente = obj
  },
  SET_LISTA_PAGO_PROVEEDOR: (state, obj) => {
    state.listaPagoProveedor = obj
  },
  SET_LISTA_CREDITO_CLIENTE: (state, obj) => {
    state.listaCreditoCliente = obj
  },
  SET_LISTA_CREDITO_PROVEEDOR: (state, obj) => {
    state.listaCreditoProveedor = obj
  },
  UPDATE_LISTA: (state, { storeList, obj }) => {
    const factura = state.lista.find(e => e._id === obj.factura._id)
    const newPago = factura.pagos.find(p => p._id === obj._id)
    // actualiza la lista de pagos (inf scroll)
    const lista = state.listaPagos.find(e => e._id === obj._id)

    if (state.listaPagos?.length) {
      if (!lista) state.listaPagos = [{ createdAt: new Date(), ...obj }, ...state.listaPagos]
      else {
        // actualiza el pago existente en la lista (inf scroll)
        lista.monto = obj.monto
        lista.concepto = obj.concepto
        lista.fecha = obj.fecha
      }
    }

    if (!newPago) {
      factura.pagos = [obj, ...factura.pagos]
      state[storeList] = [obj, ...state[storeList]]
    }
  },
  UPDATE_LISTA_COMPRAS: (state, { storeList, obj }) => {
    const factura = state.lista.find(e => e._id === obj.factura._id)
    const newPago = factura.pagos.find(p => p._id === obj._id)
    // actualiza la lista de pagos (inf scroll)
    const lista = state.listaPagosCompras.find(e => e._id === obj._id)

    if (state.listaPagosCompras?.length) {
      if (!lista) state.listaPagosCompras = [{ createdAt: new Date(), ...obj }, ...state.listaPagosCompras]
      else {
        // actualiza el pago existente en la lista (inf scroll)
        lista.monto = obj.monto
        lista.concepto = obj.concepto
        lista.fecha = obj.fecha
      }
    }

    if (!newPago) {
      factura.pagos = [obj, ...factura.pagos]
      state[storeList] = [obj, ...state[storeList]]
    }
  },
  RELOAD_LISTA: (state, { obj, _idFactura }) => {
    const factura = state.lista.find(e => e._id === _idFactura)
    factura.pagos = obj
  },
  DELETE_LIST_PAGO_FACTURA: (state, { storeList, obj }) => {
    // elimina el pago de la lista dentro de la factura
    const pago = state[storeList].find(e => e._id === obj._id)
    pago.estado = false

    // elimina el pago de la lista de pagos (inf scroll)
    const pagoEnLista = state.listaPagos?.find(e => e._id === obj._id)

    if (pagoEnLista) pagoEnLista.estado = false
  },
  DELETE_LIST_PAGO_FACTURA_COMPRAS: (state, { storeList, obj }) => {
    // elimina el pago de la lista dentro de la factura
    const pago = state[storeList].find(e => e._id === obj._id)
    pago.estado = false

    // elimina el pago de la lista de pagos compras (inf scroll)
    const pagoEnLista = state.listaPagosCompras?.find(e => e._id === obj._id)

    if (pagoEnLista) pagoEnLista.estado = false
  },
  SET_LISTA_CLIENTES: (state, obj) => {
    state.listaClientes = obj
  },
  SET_LISTA_PROVEEDOR: (state, obj) => {
    state.listaProveedor = obj
  },
  RESET_LISTA: state => {
    state.lista = []
  },
  RESET: state => {
    state.pago = { ...getDefaultState().pago }
  },
  SET: (state, { storeList, _id }) => {
    const pago = state[storeList].find(e => e._id === _id)

    if (!pago.cuentaContable) pago.cuentaContable = ''

    state.pago = pago
  },
  SET_LISTA_PAGOS: (state, obj) => {
    state.listaPagos = [...new Set([...state.listaPagos.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.listaPagosPageInfo = obj.pageInfo
  },
  SET_LISTA_PAGOS_COMPRAS: (state, obj) => {
    state.listaPagosCompras = [...new Set([...state.listaPagosCompras.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.listaPagosComprasPageInfo = obj.pageInfo
  },
  SET_PAGOS_BY_DATE: (state, obj) => {
    state.listaPagos = obj.feed
    state.listaPagosPageInfo = obj.pageInfo
  },
  SET_PAGOS_COMPRAS_BY_DATE: (state, obj) => {
    state.listaPagosCompras = obj.feed
    state.listaPagosComprasPageInfo = obj.pageInfo
  },
  SET_BALANCE_ACCOUNT: (state, obj) => {
    state.balanceAccount = {
      ingresos: obj.ingresos,
      egresos: obj.egresos
    }
  },
  SET_SALDO_CLIENTE: (state, { monto, simbolo }) => {
    state.saldoCliente = state.saldoCliente.map(s => (s.simbolo === simbolo ? { ...s, saldo: s.saldo - monto, totalPagado: s.totalPagado + monto } : s))
  },
  SET_APLICA_BALANCE: (state, value) => {
    state.aplicaBalance = value
  }
}

export const actions = {
  readPagosVentasBySearchString: async ({ state, rootGetters }, { searchString }) =>
    service.readPagosVentasBySearchString(await rootGetters['facturacion/emisorStore/get_Id'], searchString),

  readPagosComprasBySearchString: async ({ state, rootGetters }, { searchString }) =>
    service.readPagosComprasBySearchString(await rootGetters['facturacion/emisorStore/get_Id'], searchString),

  readPagosByIdFactura: ({ commit, state }, { storeList, _id }) => {
    const pagosFactura = state.lista.find(e => e._id === _id)

    if (pagosFactura) {
      commit('SET_LISTA_FACTURA', { storeList, obj: pagosFactura.pagos })

      console.log('Lista de Pagos from cache ⏩')
      return true
    }

    return service.readPagosByIdFactura(_id).then(result => {
      commit('SET_LISTA', { _id, pagos: result })
      commit('SET_LISTA_FACTURA', { storeList, obj: result })

      console.log('Lista de Pagos from DB 😫')

      return true
    })
  },

  reloadPagosByIdFactura: async ({ commit, state }, { _id, storeList }) => {
    return service.readPagosByIdFactura(_id).then(result => {
      const pagosFactura = state.lista.find(e => e._id === _id)

      commit('RELOAD_LISTA', { obj: result, _idFactura: pagosFactura._id })
      commit('SET_LISTA_FACTURA', { storeList, obj: result })

      return true
    })
  },

  readCuentasCobrarByEmisorbyDateRange: async ({ commit, rootGetters }, { filter, showNC, showPagas, showRechazadas, showLineaDetalle }) =>
    service
      .readCuentasCobrarByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], filter, showNC, showPagas, showRechazadas, showLineaDetalle)
      .then(result => {
        commit('SET_LISTA_CUENTAS_COBRAR', result)

        return true
      }),

  readCuentasPagarByEmisorbyDateRange: async ({ commit, rootGetters }, { filter, showNC, showPagas }) =>
    service.readCuentasPagarByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], filter, showNC, showPagas).then(result => {
      commit('SET_LISTA_CUENTAS_COBRAR_COMPRAS', result)

      return true
    }),

  readIngresosByEmisorbyDateRange: async ({ commit, rootGetters }, { filter, showNC }) =>
    service.readIngresosByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], filter, showNC).then(result => {
      commit('SET_LISTA_INGRESOS', result)

      return true
    }),

  readBancosByEmisor: async ({ commit, rootGetters }, { filter }) =>
    service.readBancosByEmisor(await rootGetters['facturacion/emisorStore/get_Id'], filter).then(result => {
      commit('SET_BALANCE_ACCOUNT', result)

      return true
    }),

  readEgresosByEmisorbyDateRange: async ({ commit, rootGetters }, { filter, showNC }) =>
    service.readEgresosByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], filter, showNC).then(result => {
      commit('SET_LISTA_EGRESOS', result)

      return true
    }),

  readPagosByEmisorbyDateRange: async ({ commit, rootGetters }, { filter, showNC, showPagas }) =>
    service.readPagosByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], filter, showNC, showPagas).then(result => {
      commit('SET_LISTA_PAGO', result)

      return true
    }),

  readPagosComprasByEmisorbyDateRange: async ({ commit, rootGetters }, { filter, showNC, showPagas }) =>
    service.readPagosComprasByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], filter, showNC, showPagas).then(result => {
      commit('SET_LISTA_PAGO_COMPRAS', result)

      return true
    }),

  readPagosByCliente: async ({ commit }, { cliente, showNC, isClient = true }) =>
    service.readPagosByCliente(cliente, showNC, true, isClient).then(result => {
      if (isClient) {
        commit('SET_LISTA_PAGO_CLIENTE', result)
      } else {
        commit('SET_LISTA_PAGO_PROVEEDOR', result)
      }

      return true
    }),

  readCreditoByCliente: async ({ commit }, { cliente, showNC, isClient = true }) =>
    service.readCreditoByCliente(cliente, showNC, isClient).then(result => {
      if (isClient) {
        commit('SET_LISTA_CREDITO_CLIENTE', result)
      } else {
        commit('SET_LISTA_CREDITO_PROVEEDOR', result)
      }

      return true
    }),

  readPagosClienteByEmisorbyDateRange: async ({ commit, rootGetters }, { filter, showPagas }) =>
    service.readPagosClienteByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], filter, showPagas).then(result => {
      commit('SET_LISTA_CLIENTES', result)

      return true
    }),

  readPagosProveedorByEmisorbyDateRange: async ({ commit, rootGetters }, { filter, showPagas }) =>
    service.readPagosProveedorByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], filter, showPagas).then(result => {
      commit('SET_LISTA_PROVEEDOR', result)

      return true
    }),

  delete: async ({ commit, rootGetters }, { storeList, _id, pagos }) =>
    service.delete(await rootGetters['facturacion/emisorStore/get_Id'], _id, pagos).then(result => {
      result.forEach(i => {
        if (i.state) {
          if (storeList === 'listaPagosFacturaCompras') commit('DELETE_LIST_PAGO_FACTURA_COMPRAS', { storeList, obj: i })
          else commit('DELETE_LIST_PAGO_FACTURA', { storeList, obj: i })
        }
      })
      return result
    }),

  create: async ({ commit, rootGetters, state }, { storeList, input, consecutivoFactura, cliente, simbolo }) => {
    delete input.razonEliminar
    delete input.consecutivoFactura
    delete input.cliente

    if (!input.cuentaContable) delete input.cuentaContable
    if (!input.entidad?._id) delete input.entidad

    console.log('Pago a realizar', input)

    const saldoCliente = state.saldoCliente?.find(s => s.simbolo === simbolo) || { saldo: null }

    return service
      .create({
        ...input,
        ...(saldoCliente?.saldo !== null && { saldoAFecha: Number(saldoCliente.saldo.toFixed(2)) }),
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        if (storeList) {
          if (storeList === 'listaPagosFacturaCompras') commit('UPDATE_LISTA_COMPRAS', { storeList, obj: { ...input, ...result, consecutivoFactura, cliente } })
          else commit('UPDATE_LISTA', { storeList, obj: { ...input, ...result, consecutivoFactura, cliente } })
        }

        return result
      })
  },

  pagoLink: async ({}, { input, _idEmisor }) => {
    console.log('Creando pago', input)
    return service
      .create({
        ...input,
        emisor: {
          _id: _idEmisor
        }
      })
      .then(result => {
        console.log('resultado del pago', result)
      })
  },

  resetListaPagos: ({ state }) => {
    state.listaPagos = []
    state.listaPagosPageInfo = {}
  },

  resetListaPagosCompras: ({ state }) => {
    state.listaPagosCompras = []
    state.listaPagosComprasPageInfo = {}
  },

  readPagosByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetListaPagos')

    return service
      .readPagosByEmisor(await rootGetters['facturacion/emisorStore/get_Id'], state.listaPagosPageInfo.nextPageCursor, limit, filter)
      .then(result => {
        commit('SET_LISTA_PAGOS', result)

        // if (!state.isListening) {
        //   state.isListening = true
        //   dispatch('subscriptionPago
        // }
      })
  },

  readPagosComprasByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetListaPagosCompras')

    return service
      .readPagosComprasByEmisor(await rootGetters['facturacion/emisorStore/get_Id'], state.listaPagosComprasPageInfo.nextPageCursor, limit, filter)
      .then(result => {
        commit('SET_LISTA_PAGOS_COMPRAS', result)

        // if (!state.isListening) {
        //   state.isListening = true
        //   dispatch('subscriptionPago
        // }
      })
  },

  readPagosByDateRange: async ({ commit, dispatch, state, rootGetters }, { inicio, final }) => {
    await dispatch('resetListaPagos')

    // eslint-disable-next-line no-undef
    return service.readPagosByDateRange(await rootGetters['facturacion/emisorStore/get_Id'], inicio, final).then(result => {
      return commit('SET_PAGOS_BY_DATE', result)
    })
  },

  readPagosComprasByDateRange: async ({ commit, dispatch, rootGetters }, { inicio, final }) => {
    await dispatch('resetListaPagosCompras')

    // eslint-disable-next-line no-undef
    return service.readPagosComprasByDateRange(await rootGetters['facturacion/emisorStore/get_Id'], inicio, final).then(result => {
      return commit('SET_PAGOS_COMPRAS_BY_DATE', result)
    })
  },

  readTotalDocumentos: async ({ state, rootGetters }) =>
    service.readTotalDocumentos(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      state.totalRegistros = response
    }),

  readTotalDocumentosCompras: async ({ state, rootGetters }) =>
    service.readTotalDocumentosCompras(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      state.totalRegistrosCompras = response
    }),

  readIngresosSinBancoByEmisorbyDateRange: async ({ commit, rootGetters }, { inicio, final }) =>
    service.readIngresosSinBancoByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], inicio, final).then(result => {
      return result.feed
    }),
  readEgresosSinBancoByEmisorbyDateRange: async ({ commit, rootGetters }, { inicio, final }) =>
    service.readEgresosSinBancoByEmisorbyDateRange(await rootGetters['facturacion/emisorStore/get_Id'], inicio, final).then(result => {
      return result.feed
    }),

  // mueveBancos: async ({}, { banco, cajaSesion }) => service.mueveBancos(cajaSesion, banco), TODO: revisar con el flujo conta

  readSaldoCliente: async ({ state }, { _id, isFEC = false }) => {
    return service.readSaldoCliente(_id, isFEC).then(res => {
      console.log('READ SALDO CLIENTE')
      if (res) {
        state.saldoCliente = res
      }
    })
  }
}

// export const getters = {
//   get: state => _id => {
//     const lista = state.lista.find(e => e._id.toString() === _id.toString())
//     return lista && lista.pagos && lista.pagos.length ? lista.pagos : []
//   }
// }
